export type FeatureComparisonRow = {
  category: string;
  traditionalCdp: FeatureDetails;
  hightouch: FeatureDetails;
};

export type FeatureDetails = {
  title: string;
  description: string;
};

export const dataFlexibilityComparison: FeatureComparisonRow = {
  category: "Data flexibility",
  traditionalCdp: {
    title: "Limited data flexibility",
    description: "Traditional CDPs only allow you to access and activate basic customer data like users and events.",
  },
  hightouch: {
    title: "Unlimited data flexibility",
    description:
      "Access and activate any data in your organization like complete customer profiles, data science models, product catalogs, inventory data, accounts, reservations, households, and more.",
  },
};

export const sourcesOfTruthComparison: FeatureComparisonRow = {
  category: "Sources of truth",
  traditionalCdp: {
    title: "Manage multiple sources-of-truth",
    description: "Traditional CDPs are built on duplicative data storage — your database and theirs.",
  },
  hightouch: {
    title: "Get a single source-of-truth",
    description:
      "Keep your CRM, email tools, advertising platforms, and analytics dashboards  all on the same page by storing and activating data all in one place — your existing data infrastructure.",
  },
};

export const implementationEffortComparison: FeatureComparisonRow = {
  category: "Implementation effort",
  traditionalCdp: {
    title: "6-9 month implementation",
    description:
      "Traditional CDPs require a huge lift to set up. You must integrate your existing data manually and conform to their rigid structures.",
  },
  hightouch: {
    title: "Implement your first use case in weeks",
    description:
      "Don't take a leap of faith. Hightouch is quick to set up because it is built on your existing data infrastructure. 90% of customers are fully onboarded in just days or weeks.",
  },
};

export const analyticsComparison: FeatureComparisonRow = {
  category: "Analytics",
  traditionalCdp: {
    title: "Siloed analytics",
    description:
      "Traditional CDPs have limited analytics solutions causing marketers to struggle to easily piece together insights on their campaigns from disparate sources.",
  },
  hightouch: {
    title: "Closed-loop analytics",
    description:
      "Hightouch provides highly-flexible campaign analytics allowing you to tie performance to business metrics and explore using any trait, audience, or custom parameter. ",
  },
};

export const realTimeComparison: FeatureComparisonRow = {
  category: "Real-time",
  traditionalCdp: {
    title: "Real-time, with limits",
    description:
      "Traditional CDPs limit the data you can use for real-time marketing and can take months (or years) to deploy.",
  },
  hightouch: {
    title: "Real-time unlimited",
    description:
      "Get up and running with sub-second real-time marketing that combines behavior signals with all of the data in your data warehouse.",
  },
};
